// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { useTranslation } from 'react-i18next';
import './ErrorView.less';
import type { AppError } from '@imprivata-cloud/authn';
import { ErrorCode as AuthnErrorCode } from '@imprivata-cloud/authn';
import ErrorImg from '../../assets/error-banner.svg?react';

export const ErrorView = ({ error }: { error?: AppError }) => {
  const { t } = useTranslation();

  const message =
    error?.code === AuthnErrorCode.FACTORS_INSUFFICIENT
      ? t('errors.INSUFFICIENT_FACTOR_OPTIONS')
      : t('errors.something-unexpected');

  return (
    <div className={'error-view-container'}>
      <ErrorImg aria-label="error-image" />
      <div>{message}</div>
    </div>
  );
};
